<template>
   <div :class="isOdd ? 'n_content oddBox' : 'n_content'" v-if="data.length != 0">
    <div
      class="n_signle"
      v-for="(item, index) in data"
      :key="item.id"
      @click="onInfo(item)"
    >
      <div class="n_signle_top">
        <div class="n_Name">
          {{ item.title }}
        </div>
        <div class="n_Tag" v-if="item.isNew">NEW</div>
      </div>

      <div class="n_signle_bottom">
        <div style="display: flex">
          <div
            class="n_type"
            :class="[item.signTypeName != '已结束' ? 'activeBox' : 'noActive']"
          >
            {{ item.signTypeName }}
          </div>
          <!-- <div class="n_type" :class="[item.signTypeName != '已结束' ? 'activeBox' : 'noActive']" v-if="item.typeNumber == '6'">{{ item.signTypeName }}</div> -->
          <!-- <div class="n_type" v-if="item.tenderflag"
                        :class="[typeList[item.type].lable != '单一' ? 'activeBox' : 'noActive']">{{
                            typeList[item.type].lable }}</div>
                    <div class="n_et">文件发售截止时间 <span>{{ item.endTime }}</span></div>
                    <div class="n_type" style="margin-left: 10px;" v-if="!item.tenderflag"
                        :class="[item.flag != 1 ? 'activeBox' : 'noActive']">{{ item.flag != 1 ? '正在报名' : '报名截止' }}</div> -->
        </div>
        <div class="n_ct">{{ item.createTime }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "listView",
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      },
    },
    backgroundColor: {
      type: String,
      default: "#FFFFFC",
    },
    isOdd: {
      type: Boolean,
      default: false,
    },
    typeNumber: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      typeList: [
        {
          value: 0,
          lable: "询价",
        },
        {
          value: 1,
          lable: "竞价",
        },
        {
          value: 2,
          lable: "单一",
        },
      ],
    };
  },

  mounted() {
  },
  methods: {
    onInfo(row) {
      let t = "";
      if (this.typeNumber == "0") {
        t = 2;
      } else if (this.typeNumber == "1") {
        t = 5;
      } else if (this.typeNumber == "2") {
        t = 4;
      } else if (this.typeNumber == "3") {
        t = 6;
      } else if (this.typeNumber == "4") {
        t = 7;
      }else{
        t=3
      }
      sessionStorage.setItem("projectId", row.projectId);
      sessionStorage.setItem("bulletinId", row.id);
      // let routeData =this.$router.push({
      //     path: "/purchase/info",
      //     query: {
      //         noticeId: row.noticeId,
      //         projectId: row.projectId,
      //         type: t
      //     }
      // })

      let routeData = this.$router.resolve({
        path: "/purchase/info",
        query: {
          noticeId: row.noticeId,
          projectId: row.projectId,
          type: t,
          id: row.id,
        },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.n_content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;

  .n_signle {
    cursor: pointer;
    width: 44.8%;
    border-left: 2px solid #d51900;
    padding: 20px 15px;
    background-color: #fffffc;
    margin-bottom: 20px;
    margin-right: 20px;
    line-height: 2;

    .n_signle_top,
    .n_signle_bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .n_signle_top {
      .n_Name {
        word-break: break-all;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }

    .n_signle_bottom {
      font-size: 13px;

      .n_type {
        margin-right: 10px;
        padding: 0 6px;
        border-radius: 4px;
      }

      .activeBox {
        background-color: #ffecea;
        color: #d51900;
      }

      .noActive {
        background-color: #e9e6e6;
        color: #b2b0b1;
      }

      .n_et {
        color: #b2b0b1;

        span {
          color: #d51900;
          margin-left: 10px;
        }
      }

      .n_ct {
        color: #b2b0b1;
      }
    }
  }

  // :nth-of-type(odd){
  //     margin-right: 20px;
  // }
}

.n_Tag {
  background-image: linear-gradient(
    to bottom,
    #fd5c4c,
    #f44e3c,
    #ea3f2b,
    #e02e18,
    #d51900
  );
  margin-left: 10px;
  font-size: 12px;
  padding: 0 5px;
  line-height: 2;
  color: #fff;
  border-radius: 6px;
  width: fit-content;
}

.oddBox {
  .n_signle:nth-of-type(even) {
    margin-right: 0 !important;
  }
}
</style>
